// src/App.jsx
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme/theme";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Calendar from "./pages/Calendar";
import Services from "./pages/Services";
import About from "./pages/About";
import Jobs from "./pages/Jobs";
import Live from "./pages/Live";
import MentionsLegales from "./pages/MentionsLegales";
import Ranking from "./pages/Ranking";
import Exploring from "./pages/Exploring";

export default function App() {
    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter>

                <Routes>

                    {/* Pages normales avec Navbar + Footer */}
                    <Route
                        path="/"
                        element={
                            <>
                                <Navbar />
                                <Home />
                                <Footer />
                            </>
                        }
                    />

                    <Route
                        path="/calendrier"
                        element={
                            <>
                                <Navbar />
                                <Calendar />
                                <Footer />
                            </>
                        }
                    />

                    <Route
                        path="/prestations"
                        element={
                            <>
                                <Navbar />
                                <Services />
                                <Footer />
                            </>
                        }
                    />
                    <Route
                        path="/jobs"
                        element={
                            <>
                                <Navbar />
                                <Jobs />
                                <Footer />
                            </>
                        }
                    />

                    <Route
                        path="/a-propos"
                        element={
                            <>
                                <Navbar />
                                <About />
                                <Footer />
                            </>
                        }
                    />

                    <Route
                        path="/mentions-legales"
                        element={
                            <>
                                <Navbar />
                                <MentionsLegales />
                                <Footer />
                            </>
                        }
                    />



                </Routes>

            </BrowserRouter>
        </ThemeProvider>
    );
}
